import { z } from 'zod';

export const Step1BasicSchema = z.object({
  businessLegalName: z.string().min(1, 'Business Legal Name is Required'),
  businessBrandName: z.string().min(1, 'Business Brand/Short Name is Required'),
  communicationEmail: z.string().min(1, 'Communication Email is Required').email('Communication Email is Invalid'),
  mobile: z.string().min(10, 'Invalid mobile number'),
  websiteLink: z
    .string()
    .min(1, 'Website Link is Required')
    .regex(/^(https?:\/\/)?([\w\-]+\.)+[\w\-]{2,}(\/\S*)?$/, 'Website Link is Invalid'),
  currency: z.string(),
  businessType: z.array(z.string()).min(1, 'Select at least one type'),
  industryType: z.string(),
  uploadedLogo: z.any().optional(),
});

export const Step1AddressSchema = z.object({
  country: z.string().min(1, 'Required'),
  pincode: z.string().min(6, 'Invalid pincode'),
  state: z.string().min(1, 'Required'),
  city: z.string().min(1, 'Required'),
  district: z.string().min(1, 'Required'),
  businessAddress: z.string().min(1, 'Business Address is Required'),
});

export const Step1Schema = Step1BasicSchema.merge(Step1AddressSchema);

export type Step1FormType = z.infer<typeof Step1Schema>;
